<template>
  <div class="companyOverview">
    <div class="contentBox">
      <div class="conTitle">Company News</div>
      <div
        class="contentItemBox"
        v-for="(item, index) in newsList"
        :key="index"
        @click="toDetail(item)"
      >
        <h3 class="conItemTitle">{{ item.title }}</h3>
        <p class="conItemTime">{{ item.time }}</p>
        <p class="conItemText">
          {{ item.content }}
        </p>
        <div class="more">
          EEAD MORE<i class="el-icon-arrow-right fontS"></i>
        </div>
      </div>
    </div>
    <el-backtop></el-backtop>
  </div>
</template>

<script>
import { newList } from '@/static/news.js'
export default {
  data () {
    return {
      newsList: []
    }
  },
  methods: {
    toDetail (data) {
      this.$router.push({
        path: '/companyNewsDetail',
        query: {
          id: data.id
        }
      })
    }
  },
  mounted () {
    this.newsList = newList
  }
}
</script>

<style lang="less" scoped>
.companyOverview {
  width: 100%;
  background-color: #f6f6f6;
  .contentBox {
    padding: 20px 0;
    width: 1150px;
    margin: 0 auto 0;
    .conTitle {
      font-size: 28px;
      font-weight: 700;
      border-bottom: 4px solid #0057b8;
      padding-bottom: 10px;
      color: #0057b8;
      display: inline-block;
      // font-size: 40px;
      // font-weight: 700;
      // border-bottom: 4px solid #0057b8;
      // padding-bottom: 33px;
      // margin-bottom: 20px;
      // color: #0057b8;
    }
    .contentItemBox {
      margin: 40px 0 20px;
      background-color: #fff;
      padding: 20px;
      cursor: pointer;
      border: 1px solid #f3f3f3;
      border-radius: 20px;
      box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
      .conItemTitle {
        font-size: 22px;
      }
      .conItemTime {
        margin: 40px 0;
        font-size: 20px;
        font-weight: 700;
        color: #7f7f7f;
      }
      .conItemText {
        font-size: 20px;
        margin: 40px 0;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
        -webkit-line-clamp: 5;
        text-overflow: ellipsis;
      }
      .more {
        font-size: 20px;
        font-weight: 700;
        color: #7f7f7f;
        .fontS {
          font-size: 20px;
          color: #7f7f7f;
          font-weight: 700;
        }
      }
    }
  }
  //当屏幕最小宽度为1300px
  @media screen and (min-width: 1300px) {
    .contentBox {
      transition: width 0.3s ease-in-out;
    }
  }
  //当屏幕宽度 最小为1000px 最大为1300px时
  @media screen and (min-width: 1000px) and (max-width: 1300px) {
    .contentBox {
      width: 90%;
      transition: width 0.3s ease-in-out;
    }
  }
  //当屏幕宽度 最小为800px 最大为1000px时
  @media screen and (min-width: 800px) and (max-width: 1000px) {
    .contentBox {
      width: 90%;
      transition: width 0.3s ease-in-out;
    }
  }
  //当屏幕最大宽度为800px
  @media screen and (max-width: 800px) {
    .contentBox {
      width: 90%;
      transition: width 0.3s ease-in-out;

      .conTitle {
        font-size: 16px;
        border-bottom: 2px solid #0057b8;
      }

      .contentItemBox {
      border-radius: 10px;

        .conItemTitle {
          font-size: 16px;
        }
        .conItemTime {
          font-size: 16px;
          margin: 10px 0;
        }
        .conItemText {
          font-size: 16px;
          margin: 10px 0;
        }
        .more {
          font-size: 16px;
        }
      }
    }
  }
}
</style>
